import React from "react";

const BtnMore = ( { className, txt, imgSrc, onClick } ) => {
  return (
    <div className={className}>
      <span className="pop" onClick={onClick}>
        {txt + ` `}<img src={imgSrc} alt="더보기"/>
      </span>
    </div>
  )
}

export default BtnMore;